import { IDenialCategory } from 'app/core/interfaces/deposit.interface';
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import {
  Component,
  forwardRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BilledService } from 'app/pages/billing-general/billed/billed.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { Subscription } from 'rxjs/Subscription';
import { PostingService } from 'app/core/services/posting.service';

@Component({
  selector: 'app-auto-complete-denial-category',
  templateUrl: './auto-complete-denial-category.component.html',
  styleUrls: ['./auto-complete-denial-category.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutoCompleteDenialCategoryComponent),
      multi: true,
    },
  ],
})
export class AutoCompleteDenialCategoryComponent
  implements OnInit, ControlValueAccessor, OnDestroy {
  @ViewChild('denialCategoryModal') denialCategoryModal: T2CardComponent;

  denialCategoryForm: FormGroup;
  subscriptions: Subscription[] = [];
  arrayCategoryFilter: IDenialCategory[] = [];
  searchFilterCategory = [];
  showList: boolean;
  currentSelectedId: number | null = null;
  onChangeFn = (_: any) => {};

  constructor(
    private fb: FormBuilder,
    private billedService: BilledService,
    private postingService: PostingService
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.loadCategories();
    this.closedModalDenialCategory();
  }

  initForm() {
    this.denialCategoryForm = this.fb.group({
      denialcategory: ['', Validators.required],
    });
    this.subscriptions.push(
      this.denialCategoryForm.get('denialcategory').valueChanges.subscribe((val) => {
        if (!val) {
          this.currentSelectedId = null;
          this.onChangeFn(null);
          this.arrayCategoryFilter = [];
        } else {
          this.currentSelectedId = null;
        }
      })
    );
  }

  loadCategories() {
    this.subscriptions.push(
      this.billedService.denialCategories$.subscribe({
        next: (data) => {
          this.searchFilterCategory = data || [];
        },
      })
    );
  }

  onAutoComplete(val: string) {
    if (val) {
      this.showList = true;
      this.arrayCategoryFilter = this.autocompleteMatch(val.toUpperCase());
    } else {
      this.arrayCategoryFilter = [];
    }
  }

  autocompleteMatch(input: string) {
    if (input === '') {
      return [];
    }
    const reg = new RegExp(input);
    return this.searchFilterCategory.filter((item) => {
      const descMatch = item.description && item.description.toUpperCase().match(reg);
      const speedMatch = item.speedcode && item.speedcode.toUpperCase().match(reg);
      if (descMatch || speedMatch) {
        return item;
      }
    });
  }

  onChangeCategory(item: { description: string; denialcategoryid: number }) {
    if (item && item.denialcategoryid && item.description) {
      this.denialCategoryForm.patchValue({ denialcategory: item.description });
      this.showList = false;
      this.currentSelectedId = item.denialcategoryid;
      this.onChangeFn(this.currentSelectedId);
    }
  }

  onShowDenialCategoryModal() {
    this.denialCategoryModal.open();
  }

  writeValue(value: any): void {
    const found = value
      ? this.searchFilterCategory.find((d) => d.denialcategoryid === value)
      : null;

    this.denialCategoryForm.patchValue({
      denialcategory: found && found.description ? found.description : '',
    });

    this.currentSelectedId = value ? value : null;
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(): void {}

  setDisabledState(): void {}

  closedModalDenialCategory() {
    this.subscriptions.push(
      this.postingService.closedModalDenialCategory$.subscribe((closed) => {
        if (closed) {
          this.denialCategoryModal.close();
          this.loadCategories();
        }
      })
    );
  }

  resetModal() {
    this.postingService.setClosedModalDenialCategory(false);
  }

  get getList(): boolean {
    return this.arrayCategoryFilter && this.arrayCategoryFilter.length && this.showList;
  }

  get getCategoryId(): boolean {
    return this.showList && this.denialCategoryForm.get('denialcategory').value;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/auto-complete-denial-category/auto-complete-denial-category.component.ts